import {
  SET_PAYMENT_VIRTUAL_EVENTS_FOR_ADMIN_CAPTAIN_DETAIL,
  DISPLAY_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL,
  SET_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL,
  SET_PAYMENTS_FOR_ADMIN_CAPTAIN_DETAIL,
  DISPLAY_NOTES_MODAL_FOR_ADMIN_CAPTAIN_DETAIL,
  SET_CAPTAIN_DETAILS_FOR_ADMIN,
  SET_CAPTAIN_ENTRIES_BY_TOURNAMENT_FOR_ADMIN,
  SET_CAPTAIN_BALANCE_DUE_FOR_ADMIN,
  SET_CAPTAIN_SELECTED_TOURNAMENT_VIRTUAL_EVENT_FOR_ADMIN,
  SET_CAPTAIN_SELECTED_TOURNAMENT_ENTRY_FOR_ADMIN,
  SET_CAPTAIN_COLLAPSED_TOURNAMENT_FOR_ADMIN,
  CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_DETAIL,
  DISABLE_OTHER_TOURNAMENT_SELECTION_FOR_ADMIN_CAPTAIN_DETAIL,
  DISPLAY_PAYMENT_MODAL_FOR_ADMIN_CAPTAIN_DETAIL,
  DISPLAY_UPDATE_MODAL_FOR_ADMIN_CAPTAIN_DETAIL,
  RESET_CAPTAIN_DETAILS_FOR_ADMIN,
  SHOW_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN,
  HIDE_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN,
  SET_IS_NEW_CAPTAIN_ENTRIES_MODAL_FOR_ADMIN,
  SET_AFFECTED_VIRTUAL_ENTRIES_FOR_ADMIN,
  SET_SELECTED_AFFECTED_VIRTUAL_ENTRY,
  SET_CHANGE_MULTIPLE_ENTRIES_ERRORS,
  SET_ALL_AFFECTED_VIRTUAL_ENTRIES_SELECTED,
  CHANGE_HIDE_CANCELLED_ENTRIES,
  CHANGE_HIDE_ARCHIVED_ENTRIES,
  SET_VALIDATION_MESSAGES_FOR_CAPTAIN_DETAIL
} from './constants';

export const setValidationMessages = payload => ({
  type: SET_VALIDATION_MESSAGES_FOR_CAPTAIN_DETAIL,
  payload: payload
});

export const displayUpdateModal = showModal => ({
  type: DISPLAY_UPDATE_MODAL_FOR_ADMIN_CAPTAIN_DETAIL,
  payload: showModal
});

export const setPaymentVirtualEvents = paymentVirtualEvents => ({
  type: SET_PAYMENT_VIRTUAL_EVENTS_FOR_ADMIN_CAPTAIN_DETAIL,
  payload: paymentVirtualEvents
});

export const setchangeMultipleEntriesErrors = error => ({
  type: SET_CHANGE_MULTIPLE_ENTRIES_ERRORS,
  payload: error
});

export const changeHideCancelledEntries = newValue => ({
  type: CHANGE_HIDE_CANCELLED_ENTRIES,
  payload: newValue
});

export const changeHideArchivedEntries = newValue => ({
  type: CHANGE_HIDE_ARCHIVED_ENTRIES,
  payload: newValue
});

export const displayPaymentEntries = paymentId => ({
  type: DISPLAY_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL,
  payload: paymentId
});

export const setPaymentEntries = paymentEntries => ({
  type: SET_PAYMENT_ENTRIES_FOR_ADMIN_CAPTAIN_DETAIL,
  payload: paymentEntries
});

export const setPayments = payments => ({
  type: SET_PAYMENTS_FOR_ADMIN_CAPTAIN_DETAIL,
  payload: payments
});

export const displayNotesModalVisibility = visible => ({
  type: DISPLAY_NOTES_MODAL_FOR_ADMIN_CAPTAIN_DETAIL,
  payload: visible
});

export const setCaptainDetails = captainDetails => ({
  type: SET_CAPTAIN_DETAILS_FOR_ADMIN,
  payload: captainDetails
});

export const setCaptainTournamentEntries = tournaments => ({
  type: SET_CAPTAIN_ENTRIES_BY_TOURNAMENT_FOR_ADMIN,
  payload: tournaments
});

export const setCaptainBalanceDue = balance => ({
  type: SET_CAPTAIN_BALANCE_DUE_FOR_ADMIN,
  payload: balance
});

export const setVirtualEventSelected = (tournamentId, virtualEventId) => ({
  type: SET_CAPTAIN_SELECTED_TOURNAMENT_VIRTUAL_EVENT_FOR_ADMIN,
  payload: {tournamentId, virtualEventId}
});

export const setEntrySelected = (tournamentId, entryId) => ({
  type: SET_CAPTAIN_SELECTED_TOURNAMENT_ENTRY_FOR_ADMIN,
  payload: { tournamentId, entryId }
});

export const setTournamentCollapsed = (tournamentId) => ({
  type: SET_CAPTAIN_COLLAPSED_TOURNAMENT_FOR_ADMIN,
  payload: { tournamentId }
});

export const calculateSelectedBalance = () => ({
  type: CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_DETAIL
});

export const disableOtherTournamentSelection = tournamentId => ({
  type: DISABLE_OTHER_TOURNAMENT_SELECTION_FOR_ADMIN_CAPTAIN_DETAIL,
  payload: tournamentId
});

export const displayCaptainDetailPaymentModal = showModal => ({
  type: DISPLAY_PAYMENT_MODAL_FOR_ADMIN_CAPTAIN_DETAIL,
  payload: showModal
});

export const resetCaptainDetails = () => ({
  type: RESET_CAPTAIN_DETAILS_FOR_ADMIN
});

export const displayEntryDetailChangeCaptainModal = () => ({
  type: SHOW_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN, 
  payload: true
});

export const hideEntryDetailChangeCaptainModal = () => ({
  type: HIDE_CAPTAIN_ENTRY_CHANGE_CAPTAIN_MODAL_FOR_ADMIN,
  payload: false
});

export const setIsNewCaptainOnSearch = isNew => ({
  type: SET_IS_NEW_CAPTAIN_ENTRIES_MODAL_FOR_ADMIN,
  payload: isNew
});

export const setAffectedVirtualEntries = virtualEntries => ({
  type: SET_AFFECTED_VIRTUAL_ENTRIES_FOR_ADMIN,
  payload: virtualEntries
});

export const setSelectedAffectedVirtualEntry = (virtualEntryId, selected) => ({
  type: SET_SELECTED_AFFECTED_VIRTUAL_ENTRY,
  payload: { virtualEntryId, selected }
});

export const setAllAffectedVirtualEntriesSelected = () => ({
  type: SET_ALL_AFFECTED_VIRTUAL_ENTRIES_SELECTED
});



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/actionTypes.js